/**
 * All of the colors used throughout the application
 */
export const COLORS = {
  PROVIDERS: {
    RASPBERRY: '#ff008a',
    CHERRY: '#ff0000',
    ORANGE_SLICE: '#ffa500',
    TUSCANY: '#ffe100'
  },
  EMPLOYERS: {
    BLUEBERRY: '#0059c9',
    EGGPLANT: '#7c17b9',
    FUSCIA: '#e800a9',
    VIOLET: '#d100ad'
  },
  MEMBERS: {
    BLUE_JEANS: '#00397e',
    OCEAN: '#007ec0',
    CYAN: '#00c5ff',
    BLUE_SKIES: '#009eff'
  },
  BW: {
    INK_BLACK: '#00000a',
    GUNMETAL: '#3f3f40',
    CLOUDS: '#e6e7e8',
    WHITE: '#FFFFFF'
  }
}
